import React, { useState, useEffect } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { getTopCustomersByMonth } from '../../services/apiServices';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const SalesChart = ({ onDataUpdate }) => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      
     
      const response = await getTopCustomersByMonth();
      const data = response.data;
      
      if (data && data.all_month_sales) {
        
        const chartLabels = data.all_month_sales.map(item => item.month);
        const chartValues = data.all_month_sales.map(item => 
          parseFloat(item.sale.replace(/[$,]/g, '') || '0')
        );
        
        setChartData({
          labels: chartLabels,
          datasets: [
            {
              label: 'Monthly Sales',
              data: chartValues,
              borderColor: '#FF7400',
              backgroundColor: 'rgba(255, 116, 0, 0.1)',
              borderWidth: 2,
              fill: true,
              tension: 0.4,
              pointBackgroundColor: '#FF7400',
              pointBorderColor: '#FF7400',
              pointBorderWidth: 2,
              pointRadius: 4,
              pointHoverRadius: 6,
            },
          ],
        });

        // Call the callback to update parent component data
        if (onDataUpdate) {
          onDataUpdate({ data });
        }
      }
    } catch (err) {
      setError(err.message || 'Failed to fetch sales data');
      console.error('Sales Chart API Error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: `Sales Graph`,
        font: {
          size: 20,
          weight: 'bold'
        },
        color: '#000'
      },
      tooltip: {
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        titleColor: '#666',
        bodyColor: '#000',
        borderColor: '#ddd',
        borderWidth: 1,
        cornerRadius: 8,
        displayColors: false,
        callbacks: {
          title: function(context) {
            const monthData = context[0].chart.data.labels[context[0].dataIndex];
            return `${monthData} 2025`;
          },
          label: function(context) {
            return formatCurrency(context.parsed.y);
          }
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        ticks: {
          color: '#666'
        }
      },
      y: {
        beginAtZero: true,
        grid: {
          color: 'rgba(0, 0, 0, 0.1)'
        },
        ticks: {
          color: '#666',
          callback: function(value) {
            return formatCurrency(value);
          }
        }
      },
    },
    interaction: {
      intersect: false,
      mode: 'index'
    },
    elements: {
      point: {
        hoverBackgroundColor: '#FF7400',
        hoverBorderColor: '#FF7400',
      }
    }
  };

  if (loading) {
    return (
      <div className="sales-graph">
        <h3>Sales Graph</h3>
        <div className="graph">
          <span className="loader"></span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="sales-graph">
        <h3>Sales Graph</h3>
        <div className="graph" style={{ flexDirection: 'column' }}>
          <p style={{ color: 'red', marginBottom: '10px' }}>{error}</p>
          <button onClick={fetchData} className="retry-btn">
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="sales-graph">
   
      <div className="graph">
        {chartData && <Line options={options} data={chartData} />}
      </div>
    </div>
  );
};

export default SalesChart; 